import "core-js/modules/es.function.name.js";
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
export default (function (ctx, inject) {
  var echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.PUSHER_APP_KEY,
    wsHost: process.env.PUSHER_APP_HOST,
    wsPort: process.env.PUSHER_APP_PORT,
    wssPort: process.env.PUSHER_APP_PORT,
    forceTLS: process.env.PUSHER_APP_SCHEME === 'https',
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authorizer: function authorizer(channel, options) {
      return {
        authorize: function authorize(socketId, callback) {
          var _ctx$$auth$user;

          ctx.$axios.post(process.env.PUSHER_APP_AUTH_ENDPOINT, {
            socket_id: socketId,
            channel_name: channel.name,
            participant_uuid: (_ctx$$auth$user = ctx.$auth.user) === null || _ctx$$auth$user === void 0 ? void 0 : _ctx$$auth$user.uuid
          }).then(function (response) {
            callback(false, response.data);
          }).catch(function (error) {
            callback(true, error);
          });
        }
      };
    }
  });
  inject('echo', echo);
});